import {
  Box,
  Button,
  Checkbox,
  Grid2,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  Typography,
} from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Autocomplete, TextField } from "@mui/material";

const ITEM_HEIGHT = 40;
const ITEM_PADDING_TOP = 0;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 2.5 + ITEM_PADDING_TOP,
      width: 150,
      background: "#EBF3FD",
    },
  },
};

const SelectApprovers = ({
  approvers,
  setApprovers,
  selectVendors,
  setSelectVendors,
  storedUser,
  setStep,
}) => {
  const [errors, setErrors] = useState({});
  const [orgUsers, setOrgUsers] = useState();
  const [vendors, setVendors] = useState([]);

  useEffect(() => {
    const getOrgVendors = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/vendor-org/vendors?username=${storedUser.username}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setVendors(res.data);
      } catch (error) {
        console.log(error.response.data.Exception || "Access denied");
      }
    };
    getOrgVendors();
  }, []);

  useEffect(() => {
    const getOrgUsers = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/org-user/all?username=${storedUser.username}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setOrgUsers(res.data);
      } catch (error) {
        console.log(error);
      }
    };
    getOrgUsers();
  }, []);

  const validateForm = () => {
    const newErrors = {};

    const isEmpty = (value) => !value || value.trim?.() === "";
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    // Approvers
    if (isEmpty(approvers.purchaseHead)) {
      newErrors.purchaseHead = "Purchase Manager is required";
    }

    if (isEmpty(approvers.awardee2)) {
      newErrors.awardee2 = "Awardee 2 is required";
    }

    if (!selectVendors || selectVendors.length === 0) {
      newErrors.vendors = "At least one vendor is required";
    } else {
      const invalidEmails = selectVendors.filter(
        (email) =>
          !vendors.find((v) => v.email === email) && !emailRegex.test(email)
      );
      if (invalidEmails.length > 0) {
        newErrors.vendors = `Invalid email(s): ${invalidEmails.join(", ")}`;
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNext = async () => {
    if (!validateForm()) return;
    setStep((prev) => prev + 1);
  };

  const handleApproversChange = (e) => {
    const { name, value } = e.target;
    setApprovers((prev) => ({ ...prev, [name]: value }));
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const handleVendorsChange = (e) => {
    const {
      target: { value },
    } = e;
    setSelectVendors(typeof value === "string" ? value.split(",") : value);
    setErrors({ ...errors, vendors: "" });
  };

  const handleBack = () => {
    setStep((prev) => prev - 1);
  };

  const parseEmails = (text) => {
    return text
      .split(/[\s,;]+/)
      .map((e) => e.trim())
      .filter(Boolean);
  };

  return (
    <div>
      {/* <h2>Select Approvers</h2> */}
      <div className="dashboard-container">
        <Typography className="form-title">
          Select Approvers{" "}
          <span style={{ fontSize: "12px" }}>
            (Note: Purchase Manager and Final Approver 2 are mandatory)
          </span>
        </Typography>
        <Grid2 container columnSpacing={2}>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="purchaseHead">Purchase Manager <span style={{ color: "#FF0000" }}>*</span></label>
            <Select
              className={`${errors?.purchaseHead && "input-error"}`}
              name="purchaseHead"
              id="purchaseHead"
              onChange={handleApproversChange}
              value={approvers.purchaseHead}
              IconComponent={(props) => (
                <KeyboardArrowDownIcon {...props} fontSize="small" />
              )}
              MenuProps={MenuProps}
              displayEmpty
              sx={{
                display: "flex",
                borderRadius: "7px",
                padding: "8px 7px",
                fontSize: "14px",
                margin: "7px 0 20px 0",
                "& .MuiSelect-select": {
                  fontFamily: "Inter !important",
                  padding: "5px",
                  "&:hover": { cursor: "default" },
                },
              }}
            >
              <MenuItem value="" disabled>
                Choose
              </MenuItem>
              {orgUsers &&
                orgUsers
                  .filter((user) => user.userRoleName === "PURCHASE_MANAGER" && user.isEnable)
                  .map((user) => (
                    <MenuItem key={user.email} value={user.email}>
                      {user.name}
                    </MenuItem>
                  ))}
            </Select>
            {errors?.purchaseHead && (
              <p className="error">{errors?.purchaseHead}</p>
            )}
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="awardee1">Final Approver 1</label>
            <Select
              name="awardee1"
              id="awardee1"
              value={approvers.awardee1}
              renderValue={(selected) => {
                const selectedUser = orgUsers?.find(
                  (user) => user.email === selected
                );
                return selectedUser?.name || "Choose";
              }}
              onChange={handleApproversChange}
              IconComponent={(props) => (
                <KeyboardArrowDownIcon {...props} fontSize="small" />
              )}
              MenuProps={MenuProps}
              displayEmpty
              sx={{
                display: "flex",
                borderRadius: "7px",
                padding: "8px 7px",
                fontSize: "14px",
                margin: "7px 0 20px 0",
                "& .MuiSelect-select": {
                  fontFamily: "Inter !important",
                  padding: "5px",
                  "&:hover": { cursor: "default" },
                },
              }}
            >
              <MenuItem value="">Choose</MenuItem>
              {orgUsers &&
                orgUsers
                  .filter(
                    (user) =>
                      user.userRoleName !== "BUYER" &&
                      user.userRoleName !== "PURCHASE_MANAGER" &&
                      user.email !== approvers.awardee2 &&
                      user.email !== approvers.awardee1 &&
                      user.isEnable
                  )
                  .map((user) => (
                    <MenuItem key={user.email} value={user.email}>
                      {user.name}
                    </MenuItem>
                  ))}
            </Select>
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="awardee2">Final Approver 2 <span style={{ color: "#FF0000" }}>*</span></label>
            <Select
              className={`${errors?.awardee2 && "input-error"}`}
              name="awardee2"
              id="awardee2"
              value={approvers.awardee2}
              renderValue={(selected) => {
                const selectedUser = orgUsers?.find(
                  (user) => user.email === selected
                );
                return selectedUser?.name || "Choose";
              }}
              onChange={handleApproversChange}
              IconComponent={(props) => (
                <KeyboardArrowDownIcon {...props} fontSize="small" />
              )}
              MenuProps={MenuProps}
              displayEmpty
              sx={{
                display: "flex",
                borderRadius: "7px",
                padding: "8px 7px",
                fontSize: "14px",
                margin: "7px 0 20px 0",
                "& .MuiSelect-select": {
                  fontFamily: "Inter !important",
                  padding: "5px",
                  "&:hover": { cursor: "default" },
                },
              }}
            >
              <MenuItem value="" disabled>
                Choose
              </MenuItem>
              {orgUsers &&
                orgUsers
                  .filter(
                    (user) =>
                      user.userRoleName !== "BUYER" &&
                      user.userRoleName !== "PURCHASE_MANAGER" &&
                      user.email !== approvers.awardee2 &&
                      user.email !== approvers.awardee1 &&
                      user.isEnable
                  )
                  .map((user) => (
                    <MenuItem key={user.email} value={user.email}>
                      {user.name}
                    </MenuItem>
                  ))}
            </Select>
            {errors?.awardee2 && <p className="error">{errors?.awardee2}</p>}
          </Grid2>
        </Grid2>
      </div>

      <div className="dashboard-container">
        <Typography className="form-title">Select Vendors</Typography>
        <p style={{ fontSize: "12px", marginBottom: "20px" }}>
          * Select an existing vendor or enter an email ID and press ENTER
        </p>
        <Grid2 container columnSpacing={2}>
          <Grid2 size={{ xs: 12, sm: 12 }}>
            <Autocomplete
              className={`${errors?.vendors && "input-error"} unit-dropdown`}
              multiple
              freeSolo
              options={vendors.map((v) => v.email)}
              value={selectVendors}
              onChange={(e, newValue) => setSelectVendors(newValue)}
              onPaste={(e) => {
                e.preventDefault();

                const pastedText = e.clipboardData.getData("text");
                const pastedEmails = parseEmails(pastedText);

                setSelectVendors((prev) => {
                  const merged = new Set([...prev, ...pastedEmails]);
                  return Array.from(merged);
                });

                setErrors((prev) => ({ ...prev, vendors: "" }));
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Choose Vendors"
                  variant="outlined"
                  size="small"
                  sx={{
                    "& .MuiInputBase-root": {
                      minHeight: "45px",
                      fontSize: "12px",
                    },
                    "& input": {
                      padding: "15px",
                    },
                  }}
                />
              )}
              sx={{ width: "50%", margin: "auto" }}
              slotProps={{
                paper: {
                  sx: {
                    background: "#D8E9F0",
                    "& .MuiAutocomplete-option": {
                      fontSize: "12px",
                      padding: "6px 12px",
                    },
                    "& .MuiAutocomplete-groupLabel": {
                      fontWeight: "bold",
                      color: "#000",
                      fontSize: "13px",
                      backgroundColor: "#D8E9F0",
                      padding: "0px 6px",
                      lineHeight: "2",
                      position: "static",
                    },
                  },
                },
              }}
              renderOption={(props, option, { selected }) => {
                const user = vendors.find((v) => v.email === option);
                return (
                  <li key={option} {...props}>
                    <Checkbox
                      size="small"
                      style={{ marginRight: 8 }}
                      checked={selected}
                    />
                    {`${user?.email} <${user?.firmName}>` || option}
                  </li>
                );
              }}
            />
            {errors?.vendors && (
              <p
                className="error"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: 0,
                }}
              >
                {errors.vendors}
              </p>
            )}
          </Grid2>

          {/* <Grid2 size={{ xs: 12, sm: 12 }}>
            <span style={{ fontWeight: "bold" }}>Selected Vendors:</span>{" "}
            {selectVendors
              .map(
                (email) =>
                  vendors.find((v) => v.email === email)?.email || email
              )
              .join(", ")}
          </Grid2> */}
        </Grid2>
      </div>

      <Box className="btn-container" sx={{ gap: 3 }}>
        <Button className="btn-outlined" onClick={handleBack}>
          Back
        </Button>
        <Button className="btn-contained" onClick={handleNext}>
          Next
        </Button>
      </Box>
    </div>
  );
};

export default SelectApprovers;